import clsx from "clsx";
import * as React from "react";
import styles from "./textarea.module.scss";

export interface TextareaProps extends React.ComponentProps<"textarea"> {
  textareaSize?: "sm" | "default" | "lg";
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, textareaSize = "default", ...props }, ref) => {
    return (
      <textarea
        className={clsx(
          styles.textarea,
          textareaSize === "sm" && styles.sm,
          textareaSize === "lg" && styles.lg,
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Textarea.displayName = "Textarea";

export { Textarea };
